// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
// Partials
import { PartialsModule } from '../partials/partials.module';
// Pages
import { CoreModule } from '../../core/core.module';
import { MailModule } from './apps/mail/mail.module';
import { ECommerceModule } from './apps/e-commerce/e-commerce.module';

import { MyPageComponent } from './my-page/my-page.component';
import { UserloginComponent } from './userlogin/userlogin.component';
// import { ADM0050Component } from './Hrms/hrms/Pages/adm0050/adm0050.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule } from '@angular/router';
import { AuthGuard }  from '../../core/_base/crud/utils';

@NgModule({
	declarations: [MyPageComponent, UserloginComponent],
	exports: [],
	imports: [
		CommonModule,
		HttpClientModule,
		FormsModule,
		CoreModule,
		PartialsModule,
		MailModule,
		ECommerceModule,
		NgbModule,
	],
	providers: []
})
export class PagesModule {
}
